const value2Key = ({ object, value }) =>
	Object.keys(object).filter(currValue => object[currValue] === value)[0]

export default value2Key